import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import 'draft-js/dist/Draft.css';
import {
    ConfigProvider,
    Modal,
    Skeleton,
    Select, Input, message, Upload, Popconfirm
} from 'antd';

import { saveAs } from 'file-saver'
import Banner from '../../../Reusable/Banner'
import { LabeledInput } from '../../../Reusable/Input'
import { apiPOSTReq, getPreSignedS3Url, getJwt } from '../../../../Utils/api';
import environment from '../../../../environment';
import TableView from '../../../Reusable/TableView';
import { TextButton } from '../../../Reusable/Refresh/Button'
import { Text } from '../../../Reusable/Text'
import UploadIcon from '../../../../Images/upload.svg'
import { Button } from '../../../Reusable/Button'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { ErrorAlert } from '../../../Reusable/Alert'
import { Image } from '../../../Reusable/Image';
import Download from "../../../../Images/download.png"
import Edit from '../../../../Images/edit.png'
import Link from "../../../../Images/link.png"
import Check from '../../../../Images/check-green.png'
import Copy from "../../../../Images/copy.png"
import Info from '../../../../Images/info-square.png'
import DeleteIcon from '../../../../Images/delete.svg'
import CheckBlue from '../../../../Images/check-blue.png'
import ModalClose from '../../../../Images/modal-close.png'
import File from "../../../../Images/file.png"

// Util
import { Flex, FlexColumn, LineItemsHeader, LineItemRow, LightContainer } from '../../../Reusable/Container';

// Actions

import 'react-multi-email/style.css';
import moment from 'moment';

const { Option } = Select
const { TextArea } = Input

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documentsLoading: false,
            fileList: [],
            popupLoading: false,
            pagination: {
                current: 1,
                pageSize: 100
            }
        }
    }

    componentDidMount() {
        if (this.props.type == "LoanAppDocs") {
            this.fetchData({
                pagination: {
                    current: 1,
                    pageSize: 10000
                }
            });
        }
        else {
            this.fetchBusinessAttributes();
        }

        this.props.type != "CollateralReports" && this.fetchActiveRequests({ pagination: this.state.pagination });
        getJwt((err, jwt) => {
            this.setState({ jwt });
        });
    }

    fetchBusinessDocs() {
        var { type } = this.props;
        console.log('businesskey', this.props.businessId)
        // Fetch payer list
        // Check session and fetch attributes
        const headers = {
            AionCurrentBiz: this.props.businessId
        }

        var url = (type == "Documents") ? `${environment.opsBaseUrl}/ops/fetchDocuments` : `${environment.opsBaseUrl}/ops/fetchBusinessDocuments`;

        apiPOSTReq(url, headers, {
            "clientBusinessId": this.props.businessId, rootType: (this.props.type == "CollateralReports" ? 'Collateral View Report'
                : this.props.type != "Documents" ? "FinancialReport" : 'ControlCenter')
        }, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    var businessDocs = data.businessDocuments;
                    var fileCategories = this.state.fileCategories;
                    if (this.props.type == "Documents") {
                        businessDocs = businessDocs.filter(doc => ((doc.category === "Custom Upload" && doc.subType === "AdditionalDocument")
                            || fileCategories.filter(x => x.name == doc.category).length > 0) || doc.name === "ControlCenter")
                    }
                    this.setState({ documentsLoading: true, businessDocs: businessDocs })
                } else {
                    throw Error(data.error || data.responseMessage || "Could not fetch documents")
                }
            } catch (error) {
                console.log("ERRR getActivePayors", error, err, resp);
                ErrorAlert({ description: error.message })
            }
        })
    }

    fetchData = (options) => {
        const { loanApp } = this.props;
        const { pagination } = options || {};
        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "sortDirection": "DESC"
        };
        if (loanApp) {
            body["clientBusinessId"] = this.props.businessId;
            body["applicationId"] = loanApp.applicationId;
            body["viewBy"] = "FILTER_APPLICATION_ID"
        }
        console.log("/docs/getActiveDocuments body", body);
        this.setState({ loading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/getActiveDocuments`, {}, body, (err, resp) => {
            console.log("/docs/getActiveDocuments resp", resp);
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {

                    var businessDocuments = data.businessDocuments.filter(doc => doc.category != "Owner Financials");
                    this.setState({
                        businessDocs: businessDocuments,
                        pagination: {
                            ...pagination,
                            total: data.count,
                            pageable: data.pageable
                        }, documentsLoading: true
                    });

                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                //console.log("/getPersonCards err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    fetchBusinessAttributes = () => {
        var body = {
            "clientBusinessId": ''
        };

        apiPOSTReq(`${environment.opsBaseUrl}/ops/fetchBusinessAttributes`, null, body, (err, resp) => {
            try {
                if (err) throw Error(err);
                const data = resp || {};
                if (data.result) {
                    var categories = data.businessAttributes.filter(x => x.name == "FileUploadCategories");
                    var subCategories = data.businessAttributes.filter(x => x.name == "FileUploadSubCategories");
                    this.setState({
                        fileCategories: categories[0].additionalParameterReference.parameters,
                        fileSubCategories: subCategories[0].additionalParameterReference.parameters
                    });
                    this.fetchBusinessDocs();
                } else {
                    throw Error(data.responseMessage || data.error);
                }
            } catch (error) {
                console.log("/fetchBusinessAttributes err", error, resp);
            }
        });
    }

    handleNote = (event, item) => {
        var { fileList } = this.state;
        const target = event.target;
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['id'] === item['id']) {
                fileList[i]['notes'] = target.value;
                break;
            }
        }

        this.setState({ fileList: fileList });
        event.stopPropagation();
    }

    handleDocTypeSelection = (value, item) => {
        var { fileList } = this.state;
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['id'] === item['id']) {
                fileList[i]['docType'] = value;
                fileList[i]['docSubType'] = null;
                break;
            }
        }

        this.setState({ fileList: fileList });
    }

    handleDocSubTypeSelection = (value, item) => {
        var { fileList } = this.state;
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['id'] === item['id']) {
                fileList[i]['docSubType'] = value;
                break;
            }
        }

        this.setState({ fileList: fileList });
    }

    handlePopupDeleteDoc = (uploadItem) => {
        var fileList = this.state.fileList
        var files = [];
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i].uri != uploadItem.uri) {
                files.push(fileList[i]);
            }
        }

        this.setState({ fileList: files });
    }

    handleDocSave = (item) => {
        const { UserInfo } = this.props.aionStore
        if (!this.state.editCategory) {
            ErrorAlert({ description: 'Please select a valid document category!!!' });
            return;
        }
        if (!this.state.editSubCategory) {
            ErrorAlert({ description: 'Please select a valid document sub category!!!' });
            return;
        }
        item.category = this.state.editCategory;
        item.subCategory = this.state.editSubCategory;
        var body = {
            "userEmail": `${UserInfo.Email} (${UserInfo.FirstName} ${UserInfo.LastName})`,
            "businessDocument": item
        }
        console.log("handleSubmit DOC/SAVE saveAll body", body);
        this.setState({ popupLoading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/save`, { AionCurrentBiz: this.props.businessId }, body, (err, resp) => {
            this.setState({ popupLoading: false, fileList: [] });
            try {
                const data = resp || {};
                if (data.result) {
                    this.fetchBusinessDocs();
                    this.setState({ showEditModal: false });
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/docs/save err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again" });
            }
        });
    }

    handleDocSubmit = () => {
        const { fileList } = this.state;
        const { UserInfo } = this.props.aionStore

        if (fileList.length == 0) {
            ErrorAlert({ description: 'Please upload atleast one document!!!' });
            return;
        }

        var businessDocuments = [];
        for (var i = 0; i < fileList.length; i++) {
            if (!fileList[i].docType) {
                ErrorAlert({ description: 'Please select a valid document type!!!' });
                return;
            }
            if (!fileList[i].docSubType) {
                ErrorAlert({ description: 'Please select a valid document sub type!!!' });
                return;
            }
            var businessDocument = {
                "name": "ControlCenter",
                "category": fileList[i].docType,
                "subCategory": fileList[i].docSubType,
                "documentUrl": fileList[i] || {},
                "notes": fileList[i].notes
            };
            businessDocuments.push(businessDocument);
        }

        var body = {
            "userEmail": `${UserInfo.Email} (${UserInfo.FirstName} ${UserInfo.LastName})`,
            "businessDocuments": businessDocuments
        }
        console.log("handleSubmit DOC/SAVE saveAll body", body);
        this.setState({ popupLoading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/saveAll`, { AionCurrentBiz: this.props.businessId }, body, (err, resp) => {
            this.setState({ popupLoading: false, fileList: [] });
            try {
                const data = resp || {};
                if (data.result) {
                    message.success(`File saved successfully.`, 0.75);
                    this.fetchBusinessDocs();
                    this.setState({ showUploadModal: false });
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/docs/save err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again" });
            }
        });
    }

    handleDeleteDoc = (uploadItem) => {
        var businessDocument = {
            "category": "ControlCenter",
            "name": uploadItem.name
        };

        var body = {
            "businessDocument": businessDocument,
            "documentId": uploadItem.documentId
        }

        console.log("handleSubmit DOC/delete uploadItem body", body);
        this.setState({ submitLoading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/delete`, { AionCurrentBiz: this.props.businessId }, body, (err, resp) => {
            this.setState({ submitLoading: false, loadingItem: null });
            try {
                const data = resp || {};
                if (data.result) {
                    message.success(`File Deleted successfully.`, 0.75);
                    this.fetchBusinessDocs();

                    const { aionStore } = this.props
                    var { UserInfo } = aionStore;
                    body = {
                        businessId: this.props.businessId,
                        username: UserInfo.Email || "",
                        rootType: "DeleteDocument",
                        reason: "Deleted file " + uploadItem.documentUrl.fileName + " url: " + uploadItem.documentUrl.uri
                    }

                    apiPOSTReq(`${environment.opsBaseUrl}/ops/saveAuditLogs`, { AionCurrentBiz: this.props.businessId }, body, (errr, response) => {
                        const data = response || {};
                        try {
                            if (!data.result) {
                                throw Error(data.responseMessage || data.error)
                            }
                        } catch (error) {
                            console.log("/ops/saveAuditLogs err", error, response);
                            ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again" });
                        }
                    });
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/docs/deleteUpload err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again" });
            }
        });
    }

    // Download Individual Doc
    downloadDoc = (item) => {
        const urlArr = item.documentUrl.uri.split('.');
        var fileExtension = urlArr[urlArr.length - 1];
        var filename = (item.name).includes(fileExtension) ? item.name :
            item.name == "FinancialReport" || item.name == "ControlCenter" ? item.displayName + "." + fileExtension : item.name + "." + fileExtension;
        getPreSignedS3Url({ url: item.documentUrl.uri }, async (err, preSignedUrl) => {
            try {
                // prevents opening file in new tab
                let blob = await fetch(preSignedUrl).then((r) => r.blob());
                saveAs(blob, filename);

            } catch (err) {
                console.log(err);
            }
        })
    }

    fetchActiveRequests = (options) => {
        const { loanApp } = this.props;
        const { pagination } = options || {};
        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "sortDirection": "DESC"
        };
        if (loanApp) {
            body["BusinessId"] = loanApp.businessId;
            body["applicationId"] = loanApp.applicationId;
            body["uploadCategory"] = "Custom Upload"
        }

        console.log("/lsm/getActiveLoanRequest body", body);
        this.setState({ loading: true });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getActiveLoanRequest`, null, body, (err, resp) => {
            console.log("/lsm/getActiveLoanRequest resp", resp);
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {
                    this.setState({ requests: data.requests });
                    if (data.requests.length == 0) {
                        this.setState({ showRequestedTab: false })
                    } else {
                        this.setState({ showRequestedTab: true })
                    }

                    if (options.fromButton) {
                        this.generateLink();
                    }
                    // this.fetchDocuments();
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                //console.log("/getPersonCards err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    closeCopyModal = () => {
        this.setState({ showLinkCopyModal: false, showSuccessBanner: true });
        setTimeout(() => {
            this.setState({ showSuccessBanner: false })
        }, 6000)
    }

    closeActiveRequestAlertModal = () => {
        this.setState({ hasActiveLoanApplicationRequest: false, showSuccessBanner: true });
        setTimeout(() => {
            this.setState({ showSuccessBanner: false })
        }, 6000)
    }

    generateLink = () => {
        var { loanApp } = this.props;
        const { UserInfo } = this.props.aionStore
        var username = UserInfo.Email

        var activeRequests = this.state.requests;

        if (activeRequests.length > 0) {
            this.setState({ hasActiveLoanApplicationRequest: true });
        } else {

            var requests = [];
            requests.push({
                type: "Document",
                status: 'InProgress',
                createdBy: username,
                lastUpdatedBy: username,
                documentType: "",
                period: "",
                fromDate: "",
                toDate: "",
                message: "",
                parentRequestId: false,
                allowMultipleUpload: true,
                uploadCategory: "Custom Upload"
            })

            var body = {
                applicationId: loanApp.applicationId,
                BusinessId: loanApp.businessId,
                requests: requests,
                appendRequest: false,
                generateLink: true
            }
            this.setState({ loading: true });
            console.log('Application Requests Body', body);
            apiPOSTReq(`${environment.lsmBaseUrl}/lsm/createLoanRequest`, null, body, (err, resp) => {
                this.setState({ loading: false });
                try {
                    const data = resp || {};
                    if (data.result) {
                        console.log(data);
                        this.setState({
                            uploadLink: data.doUploadLink,
                            loading: false,
                            showLinkCopyModal: true,
                            showRequestedTab: true
                        });
                        navigator.clipboard.writeText(data.doUploadLink)
                        this.fetchActiveRequests({ pagination: this.state.pagination });
                    } else {
                        throw Error(data.responseMessage || data.error)
                    }
                } catch (error) {
                    console.log("/createLoanRequest err", error, resp);
                    ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
                    this.setState({
                        loading: false
                    });
                }
            });

        }

    }

    handleEditDocTypeSelection = (value, item) => {
        var { editItem } = this.state;
        // editItem.category = value;
        this.setState({ editCategory: value, editSubCategory: null });
    }

    handleEditDocSubTypeSelection = (value, item) => {
        var { editItem } = this.state;
        // editItem.subCategory = value;
        this.setState({ editSubCategory: value });
    }

    getRowDetails = (record) => {
        return (<LightContainer fullWidth>
            <Flex style={{ width: "100%", padding: "20px", justifyContent: "space-between", alignItems: 'flex-start' }}>
                <FlexColumn style={{ width: "100%" }}>
                    <Flex start wrap gap='24px'>
                        <LabeledInput
                            label='Note'
                            key={`note`}
                            nomargin
                            type='read-only'
                            value={record.notes ? record.notes : '--'}
                        />
                    </Flex>
                </FlexColumn>
            </Flex>
        </LightContainer>
        )
    }

    render() {
        const { customize, showUploadModal, fileList, popupLoading, showLinkCopyModal, hasActiveLoanApplicationRequest,
            selectedRowId, fileCategories, fileSubCategories, showEditModal, editItem, editCategory, editSubCategory } = this.state
        const { aionStore, theme, type } = this.props
        var { Profile } = aionStore;
        var { BusinessInfo } = Profile || {};
        BusinessInfo = BusinessInfo || {};
        var columns = [];
        if (type != "CollateralReports") {
            columns.push(
                {
                    title: 'Date',
                    render: (item) => { return moment(item.auditData.createTime).format('MMM DD, YYYY') },
                    width: 200
                },
                {
                    title: 'Name',
                    render: (item) => { return item.name == "ControlCenter" ? item.documentUrl.fileName : item.name == "FinancialReport" ? item.displayName : item.name },
                    width: '40%'
                });
        }

        columns.push(
            {
                title: 'Type',
                render: (item) => { return (type != "CollateralReports") ? item.category : item.name }
            },
            type != "CollateralReports" && {
                title: 'Sub Type',
                render: (item) => { return (type != "CollateralReports") ? item.subCategory : item.name }
            },
            type == "CollateralReports" && {
                title: 'Generated on',
                render: (item) => { return moment(item.auditData.createTime).format('MMM DD, YYYY') }
            },
            // {
            //     title: 'Notes',
            //     render: (item) => { return item.notes },
            //     width: 200
            // },
            (type == "CollateralReports") && {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            },
            (type != "CollateralReports") && {
                title: 'Uploaded By',
                width: 150,
                dataIndex: 'auditData',
                render: item => item.createdBy ? item.createdBy : "System"
            },
            {
                title: 'Updated By',
                width: 150,
                dataIndex: 'auditData',
                render: item => item.lastModifiedBy && item.lastModifiedBy
            },
            {
                title: 'Action',
                align: 'center',
                render: (item) =>
                    <Flex center>
                        {
                            (item.documentUrl || {}).uri ?
                                <TextButton margin='0 24px' icon={<img width='24px' height='24px' src={Download} />} onClick={(event) => { this.downloadDoc(item); event.stopPropagation(); }} />
                                : ``
                        }
                        {
                            (type == "Documents") && <TextButton margin='0 24px' icon={<img width='24px' height='24px' src={Edit} />} onClick={(event) => { this.setState({ editItem: item, editCategory: item.category, editSubCategory: item.subCategory, showEditModal: true }); event.stopPropagation(); }} />
                        }
                        {
                            <Popconfirm
                                title={<>
                                    <div>Are you sure you want to delete this file?</div>
                                </>}
                                onConfirm={(e) => {
                                    e.stopPropagation()
                                    this.handleDeleteDoc(item)
                                }}
                                okText="Confirm"
                                placement="left"
                                cancelText="Cancel"
                                onCancel={(e) => e.stopPropagation()}
                            >
                                <TextButton margin='0 24px' icon={<img width='24px' height='24px' src={DeleteIcon} />} onClick={(event) => { event.stopPropagation(); }} />
                            </Popconfirm>
                        }
                    </Flex>
            }
        );
        var docTypeOptions = ["Financials", "Know Your Business", "Know Your Customer", "Others"];

        const uploadProps = {
            action: `${environment.apiBaseUrl}/file/upload`,
            headers: {
                businesskey: this.props.businessId,
                jwt: this.state.jwt
            },
            beforeUpload: (doc) => {
                this.setState({ uploading: true })
                var maxFileSize = 10240; // 10MB
                const uploadedFileSizeKiloBytes = doc.size / 1024
                if (uploadedFileSizeKiloBytes > maxFileSize) {
                    message.error(`File size is greater than 10MB`);
                    this.setState({ uploading: false });
                    return false;
                }
            },
            showUploadList: false,
            multiple: true,
            onChange: (info) => {
                var { dailyReportItem } = this.state;
                var savedFileList = this.state.fileList || [];
                var file = info.file;
                var { status, response, name } = file;
                if (status === "done") {
                    response = response || {};
                    savedFileList.push({
                        fileName: name,
                        uri: (response.UploadedUrls || response.uploadedUrls || [])[0],
                        file: this.props.includebase64 ? file : null
                    });
                    this.setState({ uploading: false })
                }

                var fileList = savedFileList.map((item, index) => ({ ...item, url: item.uri, id: index }));
                this.setState({ fileList: fileList });
            }
        };

        return (
            <FlexColumn>
                <ConfigProvider renderEmpty={customize && this.customizeRenderEmpty}>
                    <div className="config-provider" >
                        <Skeleton loading={!this.state.documentsLoading} active title={false} paragraph={{ rows: 4 }} className="skeleton-padding">
                            {
                                (type == "CollateralReports") &&
                                <TableView
                                    id="business-doc-table-2"
                                    className="borderless-table row-pointer"
                                    tableLayout='auto'
                                    columns={columns}
                                    dataSource={this.state.businessDocs}
                                    rowKey='id'
                                    titleText='Collateral Reports'
                                    pagination={false}
                                />
                            }
                            {
                                (type == "Documents") &&
                                <TableView
                                    id="business-doc-table-2"
                                    className="borderless-table row-pointer"
                                    tableLayout='auto'
                                    columns={columns}
                                    dataSource={this.state.businessDocs}
                                    rowKey='id'
                                    titleText='Documents'
                                    pagination={false}
                                    ctaContent={
                                        <div>
                                            <TextButton color="#40a9ff" onClick={() => this.fetchActiveRequests({ pagination: this.state.pagination, fromButton: true })} rightIcon={<img width='24px' height='24px' src={Link} />} text="GENERATE UPLOAD LINK" />
                                            <TextButton loading={this.state.uploading} text="UPLOAD DOCUMENTS" color="#40a9ff"
                                                onClick={() => {
                                                    this.setState({ showUploadModal: true, fileList: [] })
                                                }}
                                                rightIcon={<img width='24px' height='24px' src={UploadIcon} />} />
                                        </div>
                                    }
                                    onRow={
                                        (record, rowIndex) => {
                                            return {
                                                onClick: event => {
                                                    if (record['id'] == selectedRowId) {
                                                        this.setState({ selectedRowId: null })
                                                    } else {
                                                        this.setState({ selectedRowId: record['id'] })
                                                        this.getRowDetails(record)
                                                    }
                                                }, // click row
                                            }
                                        }
                                    }
                                    expand={true} // ON by default
                                    expandedRowKey={selectedRowId}
                                    getRowDetails={(record) => this.getRowDetails(record)}
                                />
                            }
                            {
                                (type == "MonthlyFinancialReports") &&
                                <TableView
                                    id="business-doc-table-2"
                                    className="borderless-table row-pointer"
                                    tableLayout='auto'
                                    columns={columns}
                                    dataSource={this.state.businessDocs}
                                    rowKey='id'
                                    titleText='Financial Reports'
                                    pagination={false}
                                />
                            }
                            {
                                (type == "LoanAppDocs") &&
                                <TableView
                                    id="business-doc-table-2"
                                    className="borderless-table row-pointer"
                                    tableLayout='auto'
                                    columns={columns}
                                    dataSource={this.state.businessDocs}
                                    rowKey='id'
                                    titleText='Loan Docs'
                                    pagination={false}
                                />
                            }
                        </Skeleton>
                    </div>
                    <Modal
                        visible={showEditModal}
                        footer={null}
                        closable={true}
                        width={600}
                        style={{ top: 10 }}
                        destroyOnClose={true}
                        onCancel={() => {
                            this.setState({
                                showEditModal: false,
                                editItem: null,
                                editCategory: null, editSubCategory: null
                            })
                        }}
                    >
                        {editItem && <FlexColumn style={{ margin: '0 10px', minHeight: "35vh", justifyContent: "space-between" }}>
                            <FlexColumn style={{ justifyContent: "flex-start" }}>
                                <Text heading>Update Document</Text>
                                <div style={{ width: 300 }}>
                                    <Text>Category:</Text>
                                    <LabeledInput
                                        labelcolor={theme.colors.secondary3}
                                        id="docType"
                                        key="docType"
                                        type="select"
                                        placeholder="Select"
                                        className="no-left-padding"
                                        mode="single"
                                        allowClear
                                        value={editCategory && editCategory}
                                        onChange={(value) => { this.handleEditDocTypeSelection(value, editItem) }}
                                    >
                                        {fileCategories && fileCategories.map(opt => (
                                            <Option key={opt.name} value={opt.name}>
                                                {opt.name}
                                            </Option>
                                        ))}
                                    </LabeledInput>
                                </div>
                                <div style={{ width: 300 }}>
                                    <Text>Sub Category:</Text>
                                    <LabeledInput
                                        labelcolor={theme.colors.secondary3}
                                        id="docSubType"
                                        key="docSubType"
                                        type="select"
                                        placeholder="Select"
                                        className="no-left-padding"
                                        mode="single"
                                        allowClear
                                        value={editSubCategory && editSubCategory}
                                        onChange={(value) => { this.handleEditDocSubTypeSelection(value, editItem) }}
                                    >
                                        {fileSubCategories && fileSubCategories.filter(x => x.value == editCategory).map(opt => (
                                            <Option key={opt.name} value={opt.name}>
                                                {opt.name}
                                            </Option>
                                        ))}
                                    </LabeledInput>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button style={{ margin: '10px 0' }} solid loading={popupLoading} onClick={(e) => this.handleDocSave(editItem)} text="Save" />
                                    <Button type="primary" style={{ alignSelf: 'center', margin: '10px 10px' }} onClick={() => { this.setState({ showEditModal: false }) }} text="Close" />
                                </div>
                            </FlexColumn>
                        </FlexColumn>}
                    </Modal>
                    <Modal
                        visible={showUploadModal}
                        footer={null}
                        closable={false}
                        width={1200}
                        style={{ top: 10 }}
                        destroyOnClose={true}
                    >
                        <FlexColumn style={{ margin: '0 10px', minHeight: "35vh", justifyContent: "space-between" }}>
                            <FlexColumn style={{ justifyContent: "flex-start" }}>
                                <Text heading>Upload Document</Text>
                                <div style={{ display: 'flex', flexDirection: 'column', minHeight: 200 }}>
                                    <Flex style={{ justifyContent: "flex-end", marginBottom: 15 }}>
                                        <Upload
                                            {...uploadProps}
                                        >
                                            <TextButton loading={this.state.uploading} text={"Add Attachments"} color="#40a9ff" icon={<PlusOutlined style={{ fontSize: 14, width: 24, height: 24, color: "#40a9ff" }} />} />
                                        </Upload>
                                    </Flex>
                                    <LineItemsHeader>
                                        <div style={{ width: 300 }}>
                                            <Text color='#333' weight='600'>{'Name'}</Text>
                                        </div>
                                        <div style={{ width: 300 }}>
                                            <Text color='#333' weight='600'>{'Type *'}</Text>
                                        </div>
                                        <div style={{ width: 300 }}>
                                            <Text color='#333' weight='600'>{'Sub Type *'}</Text>
                                        </div>
                                        <div style={{ width: 300 }}>
                                            <Text right color='#333' weight='600'>{'Notes'}</Text>
                                        </div>
                                        <div style={{ width: 50, justifyContent: 'flex-end' }}>
                                            <Text right color='#333' weight='600'></Text>
                                        </div>
                                    </LineItemsHeader>
                                    {
                                        fileList.map((lineItem, i) => {
                                            return <LineItemRow key={i + "container"}>
                                                <div style={{ width: 300 }}>
                                                    <LabeledInput
                                                        type='read-only'
                                                        value={lineItem.fileName}
                                                    />
                                                </div>
                                                <div style={{ width: 300 }}>
                                                    <LabeledInput
                                                        labelcolor={theme.colors.secondary3}
                                                        id="docType"
                                                        key="docType"
                                                        type="select"
                                                        placeholder="Select"
                                                        className="no-left-padding"
                                                        mode="single"
                                                        allowClear
                                                        value={lineItem.docType}
                                                        onChange={(value) => { this.handleDocTypeSelection(value, lineItem) }}
                                                    >
                                                        {fileCategories && fileCategories.map(opt => (
                                                            <Option key={opt.name} value={opt.name}>
                                                                {opt.name}
                                                            </Option>
                                                        ))}
                                                    </LabeledInput>
                                                </div>
                                                <div style={{ width: 300 }}>
                                                    <LabeledInput
                                                        labelcolor={theme.colors.secondary3}
                                                        id="docType"
                                                        key="docType"
                                                        type="select"
                                                        placeholder="Select"
                                                        className="no-left-padding"
                                                        mode="single"
                                                        allowClear
                                                        value={lineItem.docSubType && lineItem.docSubType}
                                                        onChange={(value) => { this.handleDocSubTypeSelection(value, lineItem) }}
                                                    >
                                                        {fileSubCategories && fileSubCategories.filter(x => x.value == lineItem.docType).map(opt => (
                                                            <Option key={opt.name} value={opt.name}>
                                                                {opt.name}
                                                            </Option>
                                                        ))}
                                                    </LabeledInput>
                                                </div>
                                                <div style={{ width: 300 }}>
                                                    <LabeledInput
                                                        type="text-area"
                                                        id="notes"
                                                        key="notes"
                                                        placeholder={`Add a note`}
                                                        onChange={(event) => { this.handleNote(event, lineItem) }}
                                                        value={lineItem.notes}
                                                    />
                                                </div>
                                                <div style={{ width: 50, justifyContent: 'flex-end' }}>
                                                    <Popconfirm
                                                        title={<>
                                                            <div>Are you sure you want to delete this file?</div>
                                                        </>}
                                                        onConfirm={(e) => {
                                                            e.stopPropagation()
                                                            this.handlePopupDeleteDoc(lineItem)
                                                        }}
                                                        okText="Confirm"
                                                        placement="left"
                                                        cancelText="Cancel"
                                                        onCancel={(e) => e.stopPropagation()}
                                                    >
                                                        <CloseOutlined style={{ color: "#40a9ff", fontSize: 14 }} />
                                                    </Popconfirm>
                                                </div>
                                            </LineItemRow>
                                        })
                                    }
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button style={{ margin: '10px 0' }} solid loading={popupLoading} onClick={this.handleDocSubmit} text="Save" />
                                    <Button type="primary" style={{ alignSelf: 'center', margin: '10px 10px' }} onClick={() => { this.setState({ showUploadModal: false }) }} text="Close" />
                                </div>
                            </FlexColumn>
                        </FlexColumn>
                    </Modal>
                    <Modal
                        visible={showLinkCopyModal}
                        footer={null}
                        closable={false}
                        width={500}
                        style={{ top: '25%' }}
                        destroyOnClose={true}
                    >
                        <FlexColumn center>
                            <Image margin='24px 0 12px' width='48px' height='48px' src={Check} />
                            <Text size='28px' height='40px' weight='500' style={{ marginBottom: 24, marginTop: 8 }}>Link Copied</Text>
                            <TextButton underline margin='0 0 24px 0' text={this.state.uploadLink} />
                            <TextButton underline margin='0 0 24px 0' onClick={() => {
                                navigator.clipboard.writeText(this.state.uploadLink)
                                this.closeCopyModal()
                            }} rightIcon={<Image src={Copy} />} text="Copy link again" />

                            <Button
                                solid
                                text={"OKAY"}
                                onClick={() => {
                                    navigator.clipboard.writeText(this.state.uploadLink)
                                    this.closeCopyModal()
                                }}
                                margin='0 0 24px'
                            />
                        </FlexColumn>
                    </Modal>
                    <Modal
                        visible={hasActiveLoanApplicationRequest}
                        footer={null}
                        closable={false}
                        width={500}
                        style={{ top: '25%' }}
                        destroyOnClose={true}
                    >
                        <FlexColumn center>
                            <Image margin='24px 0 12px' width='48px' height='48px' src={Info} />
                            <Text size='28px' height='40px' weight='500' style={{ marginBottom: 24, marginTop: 8 }}>Active request already exists</Text>
                            <Text center margin='0 12px 24px' width={'450px'}>You can only generate a new link once the prospect submits their information using the link you earlier generated.</Text>

                            <TextButton underline margin='0 0 24px 0' onClick={() => {
                                navigator.clipboard.writeText(this.state.requests[0].uploadLink)
                                this.closeActiveRequestAlertModal()
                            }} rightIcon={<Image src={Copy} />} text="Copy link again" />

                            <Button
                                solid
                                text={"OKAY"}
                                onClick={() => {
                                    navigator.clipboard.writeText(this.state.requests[0].uploadLink)
                                    this.closeActiveRequestAlertModal();
                                }}
                                margin='0 0 24px'
                            />
                        </FlexColumn>
                    </Modal>
                    {
                        this.state.showSuccessBanner &&
                        <Banner
                            background="#F5F6FE"
                            style={{ width: 320, height: 48, marginLeft: 'auto', marginRight: 'auto', position: 'sticky', zIndex: 2, bottom: "24px" }}
                            message="Link copied"
                            borderColor="#D7DCFB"
                            color="#1199FF"
                            icon={(<Image src={CheckBlue} />)}
                            cta={< Flex gap="8px" style={{ marginLeft: "20px" }}>

                                <FlexColumn>
                                    <TextButton loading={""} color='#1199FF' onClick={() => { navigator.clipboard.writeText(this.state.requests[0].uploadLink) }}
                                        text='Copy' underline weight='400' rightIcon={<Image src={File} />} style={{ padding: 0 }} />
                                </FlexColumn>
                                <FlexColumn>
                                    <TextButton loading={""} color='#E52D2D' onClick={() => { this.setState({ showSuccessBanner: false }) }}
                                        underline weight='400' icon={<Image src={ModalClose} />} />
                                </FlexColumn>
                            </Flex>
                            }
                        />
                    }
                </ConfigProvider>
            </FlexColumn >
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.creditAppReducer,
        aionStore: state.aionAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)));